import type * as React from 'react'

/**
 * mergeRefs
 *
 * code copied from https://github.com/gregberge/react-merge-refs/blob/main/src/index.tsx
 */

export function mergeRefs<T = any>(
  refs: Array<React.MutableRefObject<T> | React.LegacyRef<T> | undefined | null>
): React.RefCallback<T> {
  return value => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(value)
      } else if (ref != null) {
        const refObject = ref as React.MutableRefObject<T | null>
        refObject.current = value
      }
    })
  }
}
